import {Component} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {AuthService} from "../../../core/service/auth.service";


@Component({
  selector: 'app-info',
  templateUrl: './app-info.component.html',
  styleUrls: ['./app-info.component.css']
})
export class AppInfoComponent extends CoreComponent {

  constructor(protected router: Router,
              protected registrationApiService: RegistrationApiService,
              protected formBuilder: FormBuilder,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }


}
